// ============================================================================
// MODULE DATING - ROUTES
// Configuration des routes pour le module de rencontre
// ============================================================================

import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { DatingLayout } from '../components/dating/DatingLayout';

// Lazy loading des pages
const DatingAuthPage = lazy(() => import('../pages/dating/DatingAuthPage'));
const DatingRegistrationPage = lazy(() => import('../pages/dating/DatingRegistrationPage'));
const DatingDiscoverPage = lazy(() => import('../pages/dating/DatingDiscoverPage'));
const DatingMatchesPage = lazy(() => import('../pages/dating/DatingMatchesPage'));
const DatingMessagesPage = lazy(() => import('../pages/dating/DatingMessagesPage'));
const DatingChatPage = lazy(() => import('../pages/dating/DatingChatPage'));
const DatingProfilePage = lazy(() => import('../pages/dating/DatingProfilePage'));
const DatingPlansPage = lazy(() => import('../pages/dating/DatingPlansPage'));
const DatingSettingsPage = lazy(() => import('../pages/dating/DatingSettingsPage'));
const DatingOrderConfirmationPage = lazy(() => import('../pages/dating/DatingOrderConfirmationPage'));

// Loading component
const DatingLoading: React.FC = () => (
  <div className="min-h-screen bg-gradient-to-br from-pink-900 via-purple-900 to-indigo-900 flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
      <p className="text-white/80">Chargement...</p>
    </div>
  </div>
);

// ============================================================================
// ROUTES PROTÉGÉES (Nécessitent une authentification)
// ============================================================================

export const DatingProtectedRoutes: React.FC = () => (
  <Suspense fallback={<DatingLoading />}>
    <DatingLayout>
      <Routes>
        {/* Page principale - Découvrir */}
        <Route index element={<DatingDiscoverPage />} />
        
        {/* Matches */}
        <Route path="/matches" element={<DatingMatchesPage />} />
        
        {/* Messages */}
        <Route path="/messages" element={<DatingMessagesPage />} />
        <Route path="/messages/:conversationId" element={<DatingChatPage />} />
        
        {/* Profil */}
        <Route path="/profil" element={<DatingProfilePage />} />
        <Route path="/profil/:profileId" element={<DatingProfilePage />} />
        
        {/* Paramètres */}
        <Route path="/parametres" element={<DatingSettingsPage />} />
        
        {/* Abonnement */}
        <Route path="/abonnement" element={<DatingPlansPage />} />
        
        {/* Confirmation de commande */}
        <Route path="/confirmation/:orderId" element={<DatingOrderConfirmationPage />} />
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dating" replace />} />
      </Routes>
    </DatingLayout>
  </Suspense>
);

// ============================================================================
// COMPOSANT PRINCIPAL DES ROUTES DATING
// ============================================================================

const DatingRoutes: React.FC = () => (
  <Routes>
    {/* Routes publiques */}
    <Route path="/auth" element={
      <Suspense fallback={<DatingLoading />}>
        <DatingAuthPage />
      </Suspense>
    } />
    <Route path="/inscription" element={
      <Suspense fallback={<DatingLoading />}>
        <DatingRegistrationPage />
      </Suspense>
    } />
    <Route path="/plans" element={
      <Suspense fallback={<DatingLoading />}>
        <DatingLayout>
          <DatingPlansPage />
        </DatingLayout>
      </Suspense>
    } />
    
    {/* Routes protégées avec layout */}
    <Route path="/*" element={<DatingProtectedRoutes />} />
  </Routes>
);

export default DatingRoutes;
